<template>
  <v-container fluid grid-list-sm class="home text-xs-center">
    <v-layout row wrap align-start justify-center fill-height class="mt-3">
      <v-row dense class="py-8">
        <v-col v-for="(item, index) in menu"
               cols="10"
               offset="1">
          <v-divider v-if="item.divider" class="mt-5 mb-2"></v-divider>
          <h2>{{ item.head }}</h2>
          <v-card @click="goto(item.url)"
                  class="mt-3"
                  max-height="120"
                  min-height="60"
                  v-if="item.title"
                  style="border-left:solid 8px #0045AF;background: #e9eaeb">
            <v-card-title class="pt-3">
              <v-icon x-large
                      left
                      class="mx-5">
                {{ item.icon }}
              </v-icon>
              <div>{{ item.title }} </div> 
              <div class="countItem" v-show="item.title == 'รายการพัสดุนอกเวลา'">{{ parcelOT_count }}</div>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
    <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import EventBus from "@/EventBus";
import axios from "@/axios";

export default {
  name: "MainMenu",
async mounted() {
    window.scrollTo(0, 0)
    EventBus.$emit('set_navigation', {title: 'เมนูหลัก'});

    let localItem = this.getLocalItem();
    // localItem.user_id = 'Piampawan'
    delete localItem.itemSelected;
    delete localItem.itemsParcel;
    delete localItem.searchText;
    localStorage.setItem('parcel', JSON.stringify(localItem))
    if (localItem.role === '1' || localItem.role === 1) {
      this.menu = [
        {head: 'พัสดุในเวลา'},
        {title: 'บันทึกรับพัสดุ', icon: 'mdi-package-variant-closed', url: 'waiting-parcel'},
        {title: 'บันทึกจ่ายพัสดุ', icon: 'mdi-account-arrow-right-outline', url: 'search-parcel'},
        {divider: true},
        {head: 'พัสดุนอกเวลา'},
        {title: 'บันทึกรับพัสดุนอกเวลา', icon: 'mdi-email', url: 'ot-parcel-emp'},
        {title: 'รายการพัสดุนอกเวลา', icon: 'mdi-playlist-check', url: 'ot-list-submit'},
        {title: 'พิมพ์พัสดุนอกเวลา', icon: 'mdi-chart-box-outline', url: 'ot-parcel-report'},
        // {title: 'เพิ่มพัสดุเข้า Box24', icon: 'mdi-briefcase-plus-outline', url: 'location-box24'},
        {divider: true},
        {head: 'อื่น ๆ'},
        {title: 'สถานะพัสดุนอกเวลา', icon: 'mdi-list-status', url: 'ot-parcel-status'},
        {title: 'แก้ไขสถานะ', icon: 'mdi-clipboard-edit', url: 'status-change'},
        {title: 'แก้ไขข้อมูลลูกค้า', icon: 'mdi-account-edit', url: 'edit-customer'},
        {title: 'คู่มือพัสดุ', icon: 'mdi-file-chart', url: 'parcel-manual'},
        {title: 'Sync บ้านเลขที่', icon: 'mdi-cached', url: 'sync'},
      ]
    } else {
      this.menu = [
        {head: 'พัสดุในเวลา'},
        {title: 'บันทึกรับพัสดุ', icon: 'mdi-package-variant-closed', url: 'waiting-parcel'},
        {title: 'บันทึกจ่ายพัสดุ', icon: 'mdi-account-arrow-right-outline', url: 'search-parcel'},
        {divider: true},
        {head: 'พัสดุนอกเวลา'},
        {title: 'บันทึกรับพัสดุนอกเวลา', icon: 'mdi-email', url: 'ot-parcel-emp'},
        {title: 'รายการพัสดุนอกเวลา', icon: 'mdi-playlist-check', url: 'ot-list-submit'},        
        {title: 'พิมพ์พัสดุนอกเวลา', icon: 'mdi-chart-box-outline', url: 'ot-parcel-report'},
        // {title: 'เพิ่มพัสดุเข้า Box24', icon: 'mdi-briefcase-plus-outline', url: 'location-box24'},
        {divider: true},
        {head: 'อื่น ๆ'},
        {title: 'สถานะพัสดุนอกเวลา', icon: 'mdi-list-status', url: 'ot-parcel-status'},
        {title: 'แก้ไขข้อมูลลูกค้า', icon: 'mdi-account-edit', url: 'edit-customer'},
        {title: 'คู่มือพัสดุ', icon: 'mdi-file-chart', url: 'parcel-manual'},
      ]
    }
    
    await this.listParcelOT();
  },
  data() {
    return {
      menu: [],
      dialog: false,
      enable: true,
      iprop: '',
      parcelOT_count: 0,      
      searchData: {
          ntRunno: this.getLocalItem().nt_runno,
          status: "'W'",
      },
    }
  },
  methods: {
    async goto(route_name) {
      if (route_name === 'sync') {
        this.dialog = true
        this.enable = false
        await this.getIpropCode()
      } else {
        if (this.enable) {
          return this.$router.push({name: route_name})
        }
      }
    },
    async getAddressFromIprop() {
      try {
        axios.post('/getAddressFromIprop', {iprop: this.iprop, nt_runno: this.getLocalItem().nt_runno})
          .then(res => {
            console.log('getAddressFromIprop', res.data.data)
            // this.loopUpdate(res.data.data,res.data.data.length)
            this.dialog = false
            this.enable = true
          })
      } catch (err) {
        console.log(err.message)
      }
    },
    async loopUpdate(addr, all) {
      let count = 0
      let nt_runno = this.getLocalItem().nt_runno
      // console.log(addr)

      for (const result of addr) {
        // console.log('getAddressFromIprop forEach', res.prefix, nt_runno)
        //   await this.updateParcelAddr(nt_runno
        //     ,result.fullName
        //     ,result.prefix
        //     ,result.firstName
        //     ,result.lastName
        //     ,result.fcBuilding
        //     ,result.tmRoomH_fcCode
        //     ,result.tmRoomH_fcAddressNo
        //     ,result.fnArea
        //     ,result.fcOwnerRatio
        //     ,result.tmCOR_fcBillToMobile
        //     ,result.Owner_fcCode
        //     ,result.tmCOR_fcBillToEmail
        //     ,result.fcType)

        count++
        this.processCount = (count / all) * 100
        setTimeout(function () {
          this.processCount = (count / all) * 100
        }, 2000);
        console.log('getAddressFromIprop forEach', this.processCount)
      }

      if (this.processCount === 100) {
        this.dialog = false
        this.enable = true
      }
    },
    async getIpropCode() {
      try {
        axios.post('/getIpropCode', {nt_runno: this.getLocalItem().nt_runno})
          .then(res => {
            console.log('getIpropCode', res.data.data)
            this.iprop = res.data.data.IPROP
            this.getAddressFromIprop()
          })
      } catch (err) {
        console.log(err.message)
      }
    },
    async updateParcelAddr(nt_runno, fullName, prefix, firstName, lastName, fcBuilding, tmRoomH_fcCode, tmRoomH_fcAddressNo
      , fnArea, fcOwnerRatio, tmCOR_fcBillToMobile, Owner_fcCode, tmCOR_fcBillToEmail, fcType) {
      try {
        axios.post('/updateParcelAddr', {
          'ntrunno': nt_runno,
          'fullnames': fullName,
          'prefix': prefix,
          'fname': firstName,
          'lname': lastName,
          'building': fcBuilding,
          'pdunit': tmRoomH_fcCode,
          'addr': tmRoomH_fcAddressNo,
          'area': fnArea,
          'ratio': fcOwnerRatio,
          'mobile': tmCOR_fcBillToMobile,
          'idcard': Owner_fcCode,
          'email': tmCOR_fcBillToEmail,
          'staytype': fcType,
        }).then(res => {
          console.log('qrCreate', res.data)
        })
      } catch (err) {
        console.log(err.message)
      }
    },
    async listParcelOT() {
      try {
        await axios.post('/OTParcelList', this.searchData)
        .then(res => {
            // console.log('ParcelList', res.data.data)
            this.parcelOT_count = res.data.data.length ;
            // console.log('this.parcelOT_count', this.parcelOT_count)
        })
      } catch (err) {
          console.log(err.message)
      }
    },
  }
}
</script>

<style scoped>

.countItem {
  margin-left: auto; /* ทำให้ div นี้ชิดขวา */
  width: 30px; /* กำหนดความกว้าง */
  height: 30px; /* กำหนดความสูง */
  border-radius: 50%; /* ทำให้มุมกลม */
  background-color: red; /* สีพื้นหลังเป็นสีแดง */
  color: white; /* สีตัวอักษร */
  display: flex; /* ใช้ flex เพื่อจัดตำแหน่ง */
  justify-content: center; /* จัดกลางในแนวนอน */
  align-items: center; /* จัดกลางในแนวตั้ง */
  margin-right: 20px; /* ระยะห่างจากขอบด้านขวา */
}

</style>